import React from 'react';
import { Route, RouteProps as ReactRouteProps, useNavigate } from 'react-router-dom';
import { GlobalContext } from '../context/GlobalContext';
// services
import { useAppSelector } from '../hooks';

import { Navigate } from 'react-router-dom';

const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  debugger;
  const navigate = useNavigate();
  const { accessToken } = useAppSelector((state) => state.auth);
  return accessToken ? <>{children}</> : <Navigate to={'/login'} />;
};

export default PrivateRoute;
